import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterModule } from "@angular/router";

import { ClientServiceModal } from "./client-service/client-service.modal";
import { CompaniesModal } from "./companies/companies.modal";
import { PermissionsModal } from "./permissions/permissions.modal";
import { ProviderServiceModal } from "./provider-service/provider-service.modal";
import { UpdateServiceModal } from "./update-service/update-service.modal";
import { AssessmentsModal } from "./assessments/assessments.modal";
import { AuditDetailsModal } from "./audit-details/audit-details.modal";
import { KPIDataExportModal } from './kpidata-export/kpidata-export.modal';
import { ApptCompletionModalComponent } from "./appt-completion/appt-completion.modal";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";

@NgModule({
    declarations: [
        ClientServiceModal,
        AssessmentsModal,
        AuditDetailsModal,
        ProviderServiceModal,
        UpdateServiceModal,
        PermissionsModal,
        CompaniesModal,
        KPIDataExportModal,
        ApptCompletionModalComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        FontAwesomeModule,
        MatDatepickerModule,
        MatInputModule,
        MatNativeDateModule,
    ]
})
export class ModalsModule {}